import { IntegrationKind } from "@redotech/redo-integrations-core";
import * as z from "zod/v4";

export const syncHistoricalReviews = {
  name: "syncHistoricalReviews" as const,
  input: z.object({
    teamId: z.string(),
    kind: z.enum(IntegrationKind),
  }),
  output: z.object({
    success: z.boolean(),
    workflowId: z.string(),
    error: z.string().optional(),
  }),
};
